<template>
  <div class="helloworld column__center__center g-4">
    <h1 class="unselectable code primary-60 my-64 py-64">{{ title }}<span>|</span></h1>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data: () => ({
    title: '',
    splitted: [],
  }),
  methods: {
    setup() {
      this.title = ''
      this.splitted = [...this.$t('home.helloworld')]
      setTimeout(this.typeChar, 200)
    },
    typeChar() {
      if (this.splitted.length) {
        let char = this.splitted.shift()
        this.title = this.title + char
        setTimeout(this.typeChar, 200)
      }
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.setup()
    },
  },
  mounted() {
    this.setup()
  },
  onUpdated() {
    this.setup()
  },
}
</script>

<style lang="scss" scoped>
.helloworld {
  height: 80vh;

  h1 {
    @media (max-width: 800px) {
      font-size: 3rem;
    }
  }

  .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  span {
    animation: blink 1s infinite;
  }

  @keyframes blink {
    0% {
      opacity: 0;
    }

    49% {
      opacity: 0;
    }

    50% {
      opacity: 1;
    }

    100% {
      opacity: 1;
    }
  }
}
</style>
